import React from 'react';
import { Link } from 'react-router-dom';
import './PatentCard.css';

function PatentCard({ patent, compact = false }) {
  const renderTags = (items, type) => {
    if (!items || items.length === 0) return null;
    return (
      <div className="tag-list">
        {items.slice(0, compact ? 2 : 5).map((item, idx) => (
          <span key={idx} className={`tag ${type}`}>{item}</span>
        ))}
        {items.length > (compact ? 2 : 5) && (
          <span className="tag">+{items.length - (compact ? 2 : 5)} more</span>
        )}
      </div>
    );
  };

  return (
    <div className="patent-card">
      <Link to={`/patent/${patent.patent_id}`} className="patent-link">
        <h3 className="patent-title">{patent.title}</h3>
      </Link>
      
      <p className="patent-id">ID: {patent.patent_id}</p>
      
      {patent.plain_english_summary && (
        <p className="patent-summary">{patent.plain_english_summary}</p>
      )}
      
      {!compact && patent.technical_description && (
        <p className="patent-description">{patent.technical_description.substring(0, 200)}...</p>
      )}
      
      <div className="patent-metadata">
        {patent.domains && (
          <div className="metadata-section">
            <strong>Domains:</strong>
            {renderTags(patent.domains, 'domain')}
          </div>
        )}
        
        {patent.ipc_codes && (
          <div className="metadata-section">
            <strong>IPC Codes:</strong>
            {renderTags(patent.ipc_codes, 'ipc')}
          </div>
        )}
      </div>
    </div>
  );
}

export default PatentCard;
